import React, { useEffect, useState } from "react";

const TabletBottomBar = () => {
  const [showBar, setShowBar] = useState(false);

  useEffect(() => {
    const ua = navigator.userAgent.toLowerCase();

    const isSamsung = ua.indexOf("samsung") !== -1;
    const isXiaomi = ua.indexOf("mi pad") !== -1 || ua.indexOf("xiaomi") !== -1;

    const isTablet = true;
    //window.innerWidth >= 768 && window.innerWidth <= 1400;

    if (isTablet) {
      setShowBar(true);
    }
  }, []);

  if (!showBar) return null;

  return (
    <div
       style={{        
        width: "100%",
        height: "80px",
        background: "transparent",
      }}
    >
      
    </div>
  );
};

export default TabletBottomBar;